'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _influencerCard = require('./influencer-card');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CampaignHightlights = function CampaignHightlights(_ref) {
  var posts = _ref.posts;

  var allPosts = _lodash2.default.map(_lodash2.default.keys(posts), function (username) {
    return _lodash2.default.get(posts, username + '.posts', []);
  });
  var favouritePosts = _lodash2.default.filter(_lodash2.default.flattenDeep(allPosts), function (post) {
    var isFavouritePost = _lodash2.default.eq(_lodash2.default.get(post, 'trackedAsset.favourite', false), true);
    return isFavouritePost;
  });
  if (_lodash2.default.isEmpty(favouritePosts)) return null;
  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Card.Header,
        null,
        'Campaign Highlights'
      ),
      _react2.default.createElement(
        _semanticUiReact.Card.Description,
        null,
        'examples of the best performing posts from the campaign'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 3 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _lodash2.default.map(favouritePosts, function (post) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_influencerCard.InstagramPostBlock, post)
            );
          })
        )
      )
    )
  );
};

CampaignHightlights.propTypes = {
  posts: _propTypes2.default.array
};

CampaignHightlights.defaultProps = {
  posts: []
};

exports.default = CampaignHightlights;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/instagram-report2/campaign-highlights.js
// module id = 2193
// module chunks = 1